"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ResponsiveCell = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _getResponsiveStep = require("../styling/getResponsiveStep");

var _getResponsiveStepValues = require("../styling/getResponsiveStepValues");

var _getResponsiveValue = require("../styling/getResponsiveValue");

var _stylingConstants = require("../styling/stylingConstants");

var _useResponsiveMode = require("../styling/useResponsiveMode");

var _decorateChildren2 = require("./_decorateChildren");

var _filterChildren2 = require("./_filterChildren");

var _sortChildren2 = require("./_sortChildren");

var _ResponsiveGridContext = require("./ResponsiveGridContext");

var _ResponsiveGridMarkers = require("./ResponsiveGridMarkers");

var getClassNames = (0, _react.classNamesFunction)();

var ResponsiveCellBase = function ResponsiveCellBase(_ref) {
  var className = _ref.className,
      responsiveSteps = _ref.responsiveSteps,
      size = _ref.size,
      _ref$isFirst = _ref.isFirst,
      isFirst = _ref$isFirst === void 0 ? false : _ref$isFirst,
      _ref$isLast = _ref.isLast,
      isLast = _ref$isLast === void 0 ? false : _ref$isLast,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'column' : _ref$direction,
      styles = _ref.styles,
      children = _ref.children;
  var computed = useComputedProps(direction, size, responsiveSteps);
  var classes = getClassNames(styles, {
    pivot: computed.pivot,
    pad: computed.pad,
    size: computed.size,
    isFirst: isFirst,
    isLast: isLast,
    direction: direction
  });
  children = (0, _filterChildren2._filterChildren)(children, computed.responsiveMode, computed.responsiveSteps);
  children = (0, _sortChildren2._sortChildren)(children, computed.responsiveMode, computed.responsiveSteps);
  children = (0, _decorateChildren2._decorateChildren)(children);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _react.css)(className, classes.root),
    children: children
  });
};

var ResponsiveCell = (0, _react.styled)(ResponsiveCellBase, function (_ref2) {
  var pivot = _ref2.pivot,
      pad = _ref2.pad,
      size = _ref2.size,
      isFirst = _ref2.isFirst,
      isLast = _ref2.isLast,
      direction = _ref2.direction;
  return {
    root: [{
      display: 'flex',
      flexDirection: pivot ? 'column' : direction,
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      flex: "1 1 auto",
      minWidth: 0
    }, pivot || direction === 'row' ? {
      height: size,
      paddingTop: isFirst ? undefined : "".concat(pad / 2, "px"),
      paddingBottom: isLast ? undefined : "".concat(pad / 2, "px")
    } : {
      maxWidth: size,
      paddingLeft: isFirst ? undefined : "".concat(pad / 2, "px"),
      paddingRight: isLast ? undefined : "".concat(pad / 2, "px")
    }]
  };
});
exports.ResponsiveCell = ResponsiveCell;

_ResponsiveGridMarkers.ResponsiveGridCellMarker.mark(ResponsiveCell);

var useComputedProps = function useComputedProps(direction, size, responsiveSteps) {
  var responsiveMode = (0, _useResponsiveMode.useResponsiveMode)();
  var context = (0, React.useContext)(_ResponsiveGridContext.ResponsiveGridContext);
  var directionContext = context[context.pivot ? 'row' : direction];
  return (0, React.useMemo)(function () {
    var _context;

    responsiveSteps = (0, _getResponsiveStepValues.getResponsiveStepValues)(responsiveSteps, context.responsiveSteps);
    var sizes = (0, _map.default)(_context = (0, _getResponsiveStepValues.getResponsiveStepValues)(size, ['auto'])).call(_context, function (value) {
      return typeof value === 'number' ? "".concat(value, "px") : value;
    });
    var step = (0, _getResponsiveStep.getResponsiveStep)(responsiveMode, responsiveSteps);
    var padding = (0, _getResponsiveStepValues.getResponsiveStepValues)(directionContext.padding, [_stylingConstants.gridUnit]);
    return {
      size: (0, _getResponsiveValue.getResponsiveValue)(sizes, step, 'auto'),
      pad: (0, _getResponsiveValue.getResponsiveValue)(padding, step, _stylingConstants.gridUnit),
      pivot: context.pivot,
      responsiveMode: responsiveMode,
      responsiveSteps: responsiveSteps
    };
  }, [size, responsiveSteps, responsiveMode, directionContext.padding, context.responsiveSteps, context.pivot]);
};